<template>
  <div>
      <img :src="imgSrc" alt="">
      <!-- <button @click="print()">打印</button> -->
      <div v-show="showBtn" class="can-see">
        <button @click="print()">打印</button>
        <button @click="close()">关闭</button>
      </div>
  </div>
</template>

<script>
export default {
    name: 'printImg',
    data(){
        return {
            imgSrc:'',
            showBtn:true
        }
    },
    created:function(){
        let self = this;
        self.imgSrc = decodeURIComponent(self.$route.params.imgSrc);
    },
    methods : {
        print(){
            window.print();
        },
        close(){
            window.close();
        }
    },
    mounted(){
        let self = this;
        if(self.imgSrc != ''){
            // self.showBtn = false;
            window.print();
        }
        // window.close();
    }
}
</script>

<style scoped>
img{
    width:520px;
}
@media print {
    .can-see{
      display:none !important;
    }
  }
button{
    background-color:#0a81e5;
}
</style>



// WEBPACK FOOTER //
// printImg.vue?066f1143